import { Users, Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useOnlineUsers } from '../hooks/useOnlineUsers';

interface OnlineUserCounterProps {
  websocketUrl?: string;
  className?: string;
  showConnectionStatus?: boolean;
}

export const OnlineUserCounter: React.FC<OnlineUserCounterProps> = ({
  websocketUrl,
  className = '',
  showConnectionStatus = true
}) => {
  const { t } = useTranslation();
  const { onlineUsers, isConnected, error, reconnect } = useOnlineUsers(websocketUrl);

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* User Count */}
      <div className="flex items-center space-x-1 text-gray-700 dark:text-gray-300">
        <Users className="h-4 w-4" />
        <span className="text-sm font-medium">
          {onlineUsers} {t('onlineUsers.label')}
        </span>
      </div>
      
      {/* Connection Status */}
      {showConnectionStatus && (
        <div className="flex items-center space-x-1">
          {isConnected ? (
            <div className="flex items-center space-x-1 text-green-600 dark:text-green-400">
              <Wifi className="h-3 w-3" />
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            </div>
          ) : (
            <div className="flex items-center space-x-1 text-red-600 dark:text-red-400">
              <WifiOff className="h-3 w-3" />
              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
            </div>
          )}
        </div>
      )}
      
      {/* Error Display and Reconnect Button */}
      {error && (
        <div className="flex items-center space-x-2">
          <span className="text-xs text-red-600 dark:text-red-400 max-w-32 truncate" title={error}>
            {error}
          </span>
          <button
            onClick={reconnect}
            className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
            title={t('onlineUsers.reconnect')}
          >
            <RefreshCw className="h-3 w-3" />
          </button>
        </div>
      )}
    </div>
  );
}; 